export default __webpack_public_path__ + "static/media/redio-checked.891dc603.svg";